'use client';

import { usePathname } from 'next/navigation';
import { Spinner } from '@heroui/spinner';
import AICategorizationLoader from './repair-list/[id]/components/AICategorizationLoader';
import ThumbtackLoader from './repair-list/[id]/request/components/ThumbtackLoader';

export default function SlugLoading() {
  const pathname = usePathname();

  // Check route type - /request can be with or without trailing path
  const isRequestPage = pathname?.includes('/request');
  const isRepairList = pathname?.includes('/repair-list/') && !isRequestPage;

  // Request page - Thumbtack loader
  if (isRequestPage) {
    return (
      <div className='flex min-h-screen flex-col items-center justify-center bg-gray-100'>
        <ThumbtackLoader />
      </div>
    );
  }

  // Categorization page - AI loader
  if (isRepairList) {
    return (
      <div className='flex min-h-screen flex-col bg-gray-100'>
        <AICategorizationLoader />
      </div>
    );
  }

  // Default - Report loading
  return (
    <div className='flex min-h-screen items-center justify-center bg-gray-50'>
      <div className='flex flex-col items-center justify-center space-y-6 p-12'>
        <Spinner
          size='lg'
          color='primary'
          classNames={{
            circle1: 'border-b-primary',
            circle2: 'border-b-primary',
          }}
        />
        <div className='text-center'>
          <h2 className='text-2xl font-semibold text-gray-900'>Compiling Your Report</h2>
          <p className='mt-2 text-gray-600'>
            Please wait while we prepare your inspection report...
          </p>
        </div>
      </div>
    </div>
  );
}
